import React from 'react'
import SvgIcon, { SvgIconProps } from 'components/Luxkit/SvgIcon'

function LineClockNineIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M11 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm0 18a8.0004 8.0004 0 0 1-7.391-4.9385A8 8 0 1 1 11 20Zm0-14a1 1 0 0 0-1 1v4H8a1.0001 1.0001 0 0 0-.7071 1.7071C7.4804 12.8946 7.7348 13 8 13h3a1.0001 1.0001 0 0 0 1-1V7a1.0002 1.0002 0 0 0-1-1Z"/>
  </SvgIcon>
}

export default LineClockNineIcon
